import NumberBox from '../../NumberBox';

export interface ITextBoxProps {
	onValueChange: (data: number) => void;
}
export default class OvverideNumberBox extends NumberBox {
	readonly props: ITextBoxProps;
	constructor(props?: ITextBoxProps) {
		super();
		this.props = props;
	}
	triggerValueChanged(value: number) {
		if (this.props.onValueChange) {
			this.props.onValueChange(value);
		}
	}
}
